import type { ErrorResponseWithErrors } from '@/types/errors';

/**
 * Extracts a human-readable error message from a rejected thunk action.
 * Handles payloads with `message`, `errors[]`, string payloads,
 * or falls back to `action.error.message`.
 */
export function extractErrorMessage(
  payload: unknown,
  actionErrorMessage: string | undefined,
  fallback = 'Request failed'
): string {
  if (typeof payload === 'string') {
    return payload;
  }
  if (payload != null && typeof payload === 'object') {
    const response = payload as ErrorResponseWithErrors;
    if (response.errors?.length) {
      return response.errors[0] ?? fallback;
    }
    if (response.message) {
      return response.message;
    }
    return fallback;
  }
  return actionErrorMessage ?? fallback;
}
